import styled from 'styled-components';

export const ToolCardGroupWrapper = styled.div`
	margin-top: 1.25rem;
`;
